import { Columns2, Grid2x2, Grid3x3, Square } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SizeMenu } from 'v5/patterns/menus/SizeMenu';
import type { TileSize } from './tileSize';

export interface TileSizeMenuProps {
  value: TileSize;
  onChange: (value: TileSize) => void;
}

/** The {@link SizeMenu} of a tile grid: Small, Medium, Large and Extra large tiles. */
export function TileSizeMenu({ value, onChange }: TileSizeMenuProps) {
  const { t } = useTranslation('patterns', { keyPrefix: 'TileSizeMenu' });
  return (
    <SizeMenu
      label={t('size')}
      value={value}
      onChange={onChange}
      options={[
        // fewer, larger tiles down the list: 9, 4, 2, 1
        { value: 'small', label: t('small'), icon: <Grid3x3 /> },
        { value: 'medium', label: t('medium'), icon: <Grid2x2 /> },
        { value: 'large', label: t('large'), icon: <Columns2 /> },
        { value: 'extraLarge', label: t('extraLarge'), icon: <Square /> }
      ]}
    />
  );
}
